import React from 'react';
import { Button, ButtonGroup, Box, useBreakpointValue } from '@chakra-ui/react';

export default function Pagination({ currentPage, totalPages, onPageChange }) {
    const maxVisiblePages = 10;
    const isMobile = useBreakpointValue({ base: true, md: false });

    const createPageNumbers = () => {
        let pageNumbers = [];

        if (totalPages <= maxVisiblePages) {
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } else {
            if (currentPage <= 4) {
                pageNumbers = [1, 2, 3, 4, 5, '...', totalPages];
            } else if (currentPage > totalPages - 4) {
                pageNumbers = [1, '...', totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
            } else {
                pageNumbers = [1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages];
            }
        }

        return pageNumbers.map((number, index) =>
            number === '...' ? (
                <Box key={index} px={2} py={1} fontSize="sm">
                    ...
                </Box>
            ) : (
                <Button
                    key={index}
                    onClick={() => onPageChange(number)}
                    isActive={number === currentPage}
                    size={isMobile ? "sm" : "md"}
                >
                    {number}
                </Button>
            )
        );
    };

    return (
        <Box display="flex" justifyContent="center" mt={4} flexWrap="wrap">
            <ButtonGroup isAttached variant="outline">
                <Button
                    onClick={() => onPageChange(currentPage - 1)}
                    isDisabled={currentPage === 1}
                    size={isMobile ? "sm" : "md"}
                >
                    前
                </Button>
                {createPageNumbers()}
                <Button
                    onClick={() => onPageChange(currentPage + 1)}
                    isDisabled={currentPage === totalPages}
                    size={isMobile ? "sm" : "md"}
                >
                    次
                </Button>
            </ButtonGroup>
        </Box>
    );
}
